import { render, staticRenderFns } from "./productStockList.vue?vue&type=template&id=023618c7&scoped=true"
import script from "./productStockList.vue?vue&type=script&lang=js"
export * from "./productStockList.vue?vue&type=script&lang=js"
import style0 from "./productStockList.vue?vue&type=style&index=0&id=023618c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023618c7",
  null
  
)

export default component.exports